import { render, staticRenderFns } from "./schoolTeacherInfo.vue?vue&type=template&id=12fd29d8&scoped=true"
import script from "./schoolTeacherInfo.vue?vue&type=script&lang=js"
export * from "./schoolTeacherInfo.vue?vue&type=script&lang=js"
import style0 from "./schoolTeacherInfo.vue?vue&type=style&index=0&id=12fd29d8&prod&lang=scss&scoped=true"
import style1 from "./schoolTeacherInfo.vue?vue&type=style&index=1&id=12fd29d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd29d8",
  null
  
)

export default component.exports